/**
 * For inserting an Arrow icon
 *
 */

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const WrapArrow = ({ className, direction, hoverAnimate }) => {
  const Arrow = () => {
    // console.log("dir" + { direction });
    switch (direction) {
      case "up":
        return "↑";
      case "upRight":
        return "↗️";
      case "right":
        return "→";
      case "downRight":
        return "↘️";
      case "down":
        return "↓";
      case "downLeft":
        return "↙️";
      case "left":
        return "←";
      case "upLeft":
        return "↖️";
      default:
        return "→";
    }
  };

  return (
    <span
      className={classNames(
        "inline-block",
        "font-sans-symbols",
        "transition-all duration-200 ease-in-out",
        direction === "left" ? "pl-[0.2em] group-hover:-translate-x-2" : "",
        direction === "right" ? "pr-[0.2em] group-hover:translate-x-2" : "",
        '[font-variation-settings:"ALTR"0] group-hover:[font-variation-settings:"ALTR"100]',
        hoverAnimate ? "group-hover:animate-symbol-bounce" : "",
        className
      )}
    >
      <Arrow />
    </span>
  );
};

WrapArrow.propTypes = {
  /** Classname */
  className: PropTypes.string,
  /** Arrow direction: up, upRight, right (default), downRight, down, downLeft, left, upLeft */
  direction: PropTypes.string,
  /** Whether or not to animate the arrow on hover (default false) */
  hoverAnimate: PropTypes.bool,
};

export default WrapArrow;
